import { Outlet, type RouteObject } from "react-router-dom";
import { NotFound } from "../../components/not-found.components";

import { authRouter } from "./auth.router";
import { PrivateBrandRoute } from "../../components/private-route.components";
import { brandRouter } from "./brand.router";
import { BaseBrandsLayoutScreen } from "../screens/base-brands.layouts.screen";
import AuthLayoutScreen from "../screens/auth/auth-layout.screen";
import ProposalScreen from "../screens/proposal/proposal.screen";

export const baseBrandsRouter: Array<RouteObject> = [
  {
    path: "",
    element: (
      <PrivateBrandRoute>
        <BaseBrandsLayoutScreen />
      </PrivateBrandRoute>
    ),
    children: brandRouter,
  },

  {
    path: "auth",
    element: <AuthLayoutScreen />,
    children: authRouter,
  },

  {
    path: "proposal",
    element: <Outlet />,
    children: [
      {
        path: ":proposalId",
        element: <ProposalScreen />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
